export const enum ApiType {
  go = 'GO',
  python = 'PYTHON',
  media = 'MEDIA',
  V3 = 'V3',
}

export const apiType = {
  go: 'GO',
  python: 'PYTHON',
  media: 'MEDIA',
  V3: 'V3',
} as const;
